import {
    ADD_BANKING,
    ADD_BANKING_SUCCESS,
    ADD_BANKING_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
    loading: false,
    addBankingDetails: [],
};

const addBankingReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ADD_BANKING:
            return { ...state, loading: true };
        case ADD_BANKING_SUCCESS:
            return {
                ...state,
                addBankingDetails: action?.payload,
                loading: false,
            };
        case ADD_BANKING_FAILURE:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default addBankingReducer;
